import React, { useEffect, useState, useRef } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Layout from "../layout/Layout";
import ContentWrapper from "../components/ContentWrapper";
import { useDispatch, useSelector } from "react-redux";
import { careseekerlist, updatestaus } from "../Redux/Action/CareSeekerAction";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay-ts";
import DeleteModal from "../Component/DeleteModal";
import Pagination from "../Component/Pagination";
import Flag from "react-flagkit";
import Contry from "../Component/Contry";
import { userexport } from "../Redux/Action/SubAdmin";
import FirstLetterCapital from "../CustomHooks/FirstLetterCapital";
import moment from "moment";
import BlockModal from "../Component/BlockModal";
import VerificationModal from "../Component/VerificationModal";
import { getOptimizedImageUrl, IMAGE_SIZES } from "../utils/imageOptimization";
import defaultAvatar from "../assets/images/default-avatar.png";

export default function UserList({ role, detailsRoute, title, defaultFilters = {} }) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState();
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [showblock, setShowblock] = useState(false);
  const [blockTitle, setBlockTitle] = useState(false);
  const [userObject, setUserObject] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [limit] = useState(10);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState(defaultFilters);
  const [filterUI, setFilterUI] = useState({
    role: role || '',
    is_deleted: defaultFilters.is_deleted ?? false,
    isCompleted: defaultFilters['profile_status.isCompleted'],
    email: '',
  });
  const navigate = useNavigate();

  const statusOptions = [
    { label: "All", value: "all" },
    { label: "Completed", value: "completed" },
    { label: "Incomplete", value: "incomplete" },
    { label: "Deleted", value: "deleted" },
  ];
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const statusDropdownRef = useRef(null);

  // Default: only completed
  const [statusSelected, setStatusSelected] = useState(["completed"]);

  // Map status selection to filter values
  const getStatusFilters = (selected) => {
    const filters = {};
    if (selected.includes("all")) return filters; // No status filter if 'All' selected
    if (selected.includes("completed")) filters["profile_status.isCompleted"] = true;
    if (selected.includes("incomplete")) filters["profile_status.isCompleted"] = false;
    if (selected.includes("deleted")) filters.is_deleted = true;
    if (!selected.includes("deleted")) filters.is_deleted = false;
    return filters;
  };

  // Update filters when any filter changes (auto-apply)
  useEffect(() => {
    const newFilters = {
      ...defaultFilters,
      ...getStatusFilters(statusSelected),
    };
    // Don't set role in filters here, handle it in API calls
    if (filterUI.email) newFilters.email = filterUI.email;
    setFilters(newFilters);
    setPage(1);
    // eslint-disable-next-line
  }, [statusSelected, filterUI.role, filterUI.email]);

  // Dropdown close on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
        setStatusDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setLoading(true);
    const payload = {
      filters: { 
        ...filters, 
        ...(filterUI.role && filterUI.role.trim() ? { role: [filterUI.role] } : {}),
        ...(filterUI.email && filterUI.email.trim() ? { email: filterUI.email } : {}) 
      },
      limit,
      page,
    };
    if (search) payload.search = search;
    console.log('UserList API payload:', JSON.stringify(payload, null, 2));
    dispatch(
      careseekerlist(payload)
    ).then(() => setLoading(false));
    // eslint-disable-next-line
  }, [filters, search, limit, page]);

  const list = useSelector((state) => state.careseeker.careseekerArr);

  function calculateAge(dob) {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return isNaN(age) === true ? "N/A" : age;
  }

  const handleDelete = () => {
    setLoading(true);
    const payload = {
      filters: { 
        ...filters, 
        ...(filterUI.role && filterUI.role.trim() ? { role: [filterUI.role] } : {}),
        ...(filterUI.email && filterUI.email.trim() ? { email: filterUI.email } : {}) 
      },
      limit,
      page,
    };
    if (search) payload.search = search;
    console.log('UserList API payload (delete):', payload);
    dispatch(
      updatestaus({
        userId: userObject._id,
        is_deleted: true,
      })
    ).then(() => {
      setShow(false);
      dispatch(
        careseekerlist(payload)
      ).then(() => setLoading(false));
    });
  };

  const searchdata = () => {
    setLoading(true);
    const payload = {
      filters: { 
        ...filters, 
        ...(filterUI.role && filterUI.role.trim() ? { role: [filterUI.role] } : {}),
        ...(filterUI.email && filterUI.email.trim() ? { email: filterUI.email } : {}) 
      },
      limit,
      page,
    };
    if (search) payload.search = search;
    console.log('UserList API payload (search):', payload);
    dispatch(
      careseekerlist(payload)
    ).then(() => setLoading(false));
  };

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const exportcsv = async () => {
    const header = [
      { id: "first_name", title: "First Name" },
      { id: "last_name", title: "Last Name" },
      { id: "email", title: "Email" },
      { id: "role", title: "Role" },
      { id: "phone_number", title: "Mobile Number" },
      { id: "gender", title: "Gender" },
      { id: "age", title: "Age" },
    ];
    const payload = { 
      header, 
      filters: { 
        ...filters, 
        ...(filterUI.role && filterUI.role.trim() ? { role: [filterUI.role] } : {}),
        ...(filterUI.email && filterUI.email.trim() ? { email: filterUI.email } : {}) 
      } 
    };
    if (search) payload.search = search;
    console.log('UserList API payload (export):', payload);
    dispatch(userexport(payload)).then(function (info) {
      window.location.href = info.payload;
    });
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      searchdata();
    }
  };

  const handleBlockActive = () => {
    dispatch(
      updatestaus({
        userId: userObject._id,
        is_active: userObject.is_active === true ? false : true,
      })
    ).then(function () {
      const payload = {
        filters: { 
          ...filters, 
          ...(filterUI.role && filterUI.role.trim() ? { role: [filterUI.role] } : {}),
          ...(filterUI.email && filterUI.email.trim() ? { email: filterUI.email } : {}) 
        },
        limit,
        page,
      };
      if (search) payload.search = search;
      console.log('UserList API payload (block):', payload);
      dispatch(
        careseekerlist(payload)
      );
      setShowblock(false);
    });
  };

  const handleRestore = (user) => {
    setLoading(true);
    const payload = {
      filters: { 
        ...filters, 
        ...(filterUI.role && filterUI.role.trim() ? { role: [filterUI.role] } : {}),
        ...(filterUI.email && filterUI.email.trim() ? { email: filterUI.email } : {}) 
      },
      limit,
      page,
    };
    if (search) payload.search = search;
    console.log('UserList API payload (restore):', payload);
    dispatch(
      updatestaus({
        userId: user._id,
        is_deleted: false,
      })
    ).then(() => {
      dispatch(
        careseekerlist(payload)
      ).then(() => setLoading(false));
    });
  };

  // Custom filter UI handlers
  const handleStatusSelect = (value) => {
    if (value === "all") {
      setStatusSelected(["all"]);
    } else {
      setStatusSelected((prev) => {
        let next = prev.filter((v) => v !== "all");
        if (next.includes(value)) {
          next = next.filter((v) => v !== value);
        } else {
          next = [...next, value];
        }
        if (next.length === 0) next = ["all"];
        return next;
      });
    }
  };
  const handleStatusRemove = (value) => {
    setStatusSelected((prev) => {
      let next = prev.filter((v) => v !== value && v !== "all");
      if (next.length === 0) next = ["all"];
      return next;
    });
  };
  const clearFilters = () => {
    setFilterUI({
      role: role || '',
      is_deleted: defaultFilters.is_deleted ?? false,
      isCompleted: defaultFilters['profile_status.isCompleted'] ?? true,
      email: '',
    });
    setStatusSelected(["completed"]);
    setFilters(defaultFilters);
    setPage(1);
  };

  return (
    <Layout>
      <LoadingOverlay active={loading} text="Loading data...">
        <ContentWrapper title={title ? title : 'Users'}>
            {/* Enhanced Filter Bar */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 mb-6">
              {/* Filter Header */}
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                  <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center">
                    <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">Filter Users</h3>
                </div>
                <div className="text-sm text-gray-500">
                  {list?.totalItems || 0} total users
                </div>
              </div>

              {/* Search Bar - Full Width */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <span className="flex items-center">
                    <svg className="w-4 h-4 mr-1 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    Search Users
                  </span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                  <input
                    type="text"
                    placeholder="Search by name, email, or phone..."
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    onKeyDown={handleSearchKeyDown}
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                  />
                  {search && (
                    <button
                      onClick={() => setSearch('')}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>

              {/* Filter Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <span className="flex items-center">
                      <svg className="w-4 h-4 mr-1 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      User Role
                    </span>
                  </label>
                  <select
                    name="role"
                    value={filterUI.role}
                    onChange={e => setFilterUI(prev => ({ ...prev, role: e.target.value }))}
                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors bg-white"
                  >
                    <option value="">All Roles</option>
                    <option value="carer">Carer</option>
                    <option value="care seeker">Care Seeker</option>
                  </select>
                </div>

                <div className="relative" ref={statusDropdownRef}>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <span className="flex items-center">
                      <svg className="w-4 h-4 mr-1 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Account Status
                    </span>
                  </label>
                  <div
                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-white cursor-pointer focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 flex items-center justify-between min-h-[42px] transition-colors"
                    onClick={() => setStatusDropdownOpen((open) => !open)}
                  >
                    <div className="flex flex-wrap gap-1">
                      {statusSelected.length === 0 && (
                        <span className="text-gray-500">Select status...</span>
                      )}
                      {statusSelected.map((val) => {
                        const opt = statusOptions.find((o) => o.value === val);
                        return (
                          <span key={val} className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-emerald-100 text-emerald-800">
                            {opt?.label}
                            {val !== 'all' && (
                              <button
                                className="ml-1 text-emerald-600 hover:text-emerald-800 transition-colors"
                                onClick={e => { e.stopPropagation(); handleStatusRemove(val); }}
                              >
                                ×
                              </button>
                            )}
                          </span>
                        );
                      })}
                    </div>
                    <svg className={`w-4 h-4 text-gray-400 transition-transform ${statusDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                  {statusDropdownOpen && (
                    <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-10 max-h-48 overflow-y-auto">
                      {statusOptions.map((opt) => (
                        <div
                          key={opt.value}
                          className={`px-3 py-2 cursor-pointer hover:bg-emerald-50 flex items-center justify-between transition-colors ${
                            statusSelected.includes(opt.value) ? "bg-emerald-50 text-emerald-700" : "text-gray-700"
                          }`}
                          onClick={e => { e.stopPropagation(); handleStatusSelect(opt.value); }}
                        >
                          <span className="flex items-center">
                            <div className={`w-2 h-2 rounded-full mr-2 ${
                              opt.value === 'completed' ? 'bg-green-500' :
                              opt.value === 'incomplete' ? 'bg-yellow-500' :
                              opt.value === 'deleted' ? 'bg-red-500' : 'bg-gray-500'
                            }`}></div>
                            {opt.label}
                          </span>
                          {statusSelected.includes(opt.value) && (
                            <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              
              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pt-4 border-t border-gray-200">
                <div className="flex items-center space-x-3">
                  <button
                    className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                    onClick={clearFilters}
                  >
                    <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    Clear Filters
                  </button>
                  
                  {(search || filterUI.role || statusSelected.length > 0) && (
                    <div className="text-sm text-gray-500">
                      {[search && 'search', filterUI.role && 'role', statusSelected.length > 0 && 'status'].filter(Boolean).length} filter(s) active
                    </div>
                  )}
                </div>

                <button 
                  className="inline-flex items-center px-4 py-2 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 transition-colors"
                  onClick={exportcsv}
                >
                  <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Export CSV
                </button>
              </div>
            </div>
            
            {/* Enhanced Table */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              {/* Table Header */}
              <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-emerald-50 to-emerald-100">
                <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                  <svg className="w-5 h-5 mr-2 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  Users ({list?.totalItems || 0})
                </h3>
              </div>

              {/* Table Content */}
              <div className="overflow-x-auto">
                <table className="w-full responsive-table">
                  <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        User
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Role & Status
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Contact Info
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Profile Details
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Joined
                      </th>
                      <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-100">
                    {list?.data?.map((object, i) => (
                      <tr
                        key={i}
                        className="hover:bg-gray-50 transition-colors duration-200 group"
                      >
                        {/* User Column */}
                        <td data-label="User" className="px-6 py-4">
                          <div className="flex items-center space-x-3">
                            <div className="relative">
                              <img
                                src={getOptimizedImageUrl(object.profile_picture, 'AVATAR_SMALL') || defaultAvatar}
                                alt="profile"
                                onError={(e) => { e.currentTarget.src = defaultAvatar; }}
                                className="w-10 h-10 rounded-full object-cover ring-2 ring-gray-200 group-hover:ring-emerald-300 transition-all duration-200"
                              />
                              {object.shufti_verification && (
                                <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full flex items-center justify-center">
                                  <svg className="w-2.5 h-2.5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                  </svg>
                                </div>
                              )}
                            </div>
                            <div className="min-w-0 flex-1">
                              <p className="text-sm font-semibold text-gray-900 truncate">
                                {FirstLetterCapital(object?.first_name + " " + object?.last_name)}
                              </p>
                              <p className="text-xs text-gray-500">
                                ID: {object._id?.slice(-8)}
                              </p>
                            </div>
                          </div>
                        </td>

                        {/* Role & Status Column */}
                        <td data-label="Role & Status" className="px-6 py-4">
                          <div className="space-y-2">
                            {object?.role && (
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                object.role === 'carer'
                                  ? 'bg-blue-100 text-blue-800'
                                  : object.role === 'care seeker'
                                  ? 'bg-purple-100 text-purple-800'
                                  : 'bg-gray-100 text-gray-800'
                              }`}>
                                {FirstLetterCapital(object?.role)}
                              </span>
                            )}
                            <div>
                              {object?.is_deleted ? (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                  </svg>
                                  Deleted
                                </span>
                              ) : object?.is_active === true ? (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                  </svg>
                                  Active
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                  </svg>
                                  Blocked
                                </span>
                              )}
                            </div>
                          </div>
                        </td>

                        {/* Contact Info Column */}
                        <td data-label="Contact Info" className="px-6 py-4">
                          <div className="space-y-1">
                            <div className="flex items-center text-sm text-gray-900">
                              <svg className="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                              </svg>
                              <span className="truncate max-w-[150px]" title={object?.email}>
                                {object?.email}
                              </span>
                            </div>
                            {object?.phone?.country_code && (
                              <div className="flex items-center text-sm text-gray-600">
                                <svg className="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                </svg>
                                <Flag country={Contry(object?.phone?.country_code)} size={16} className="mr-1" />
                                <span className="text-xs">
                                  {object?.phone?.country_code} {object?.phone?.number}
                                </span>
                              </div>
                            )}
                          </div>
                        </td>

                        {/* Profile Details Column */}
                        <td data-label="Profile Details" className="px-6 py-4">
                          <div className="space-y-1 text-sm">
                            <div className="flex items-center text-gray-600">
                              <span className="text-xs text-gray-500 w-12">Gender:</span>
                              <span className="text-gray-900">{FirstLetterCapital(object?.gender) || "N/A"}</span>
                            </div>
                            <div className="flex items-center text-gray-600">
                              <span className="text-xs text-gray-500 w-12">Age:</span>
                              <span className="text-gray-900">{calculateAge(object?.date_of_birth)}</span>
                            </div>
                            {moment(object?.date_of_birth).isValid() && (
                              <div className="text-xs text-gray-500">
                                DOB: {moment(object?.date_of_birth).format("DD MMM YYYY")}
                              </div>
                            )}
                          </div>
                        </td>

                        {/* Joined Column */}
                        <td data-label="Joined" className="px-6 py-4">
                          <div className="text-sm">
                            <div className="text-gray-900 font-medium">
                              {moment(object?.createdAt).isValid()
                                ? moment(object?.createdAt).format("MMM D, YYYY")
                                : "N/A"}
                            </div>
                            <div className="text-xs text-gray-500">
                              {moment(object?.createdAt).isValid()
                                ? moment(object?.createdAt).format("h:mm A")
                                : ""}
                            </div>
                          </div>
                        </td>

                        {/* Actions Column */}
                        <td data-label="Actions" className="px-6 py-4">
                          <div className="flex items-center justify-center space-x-2">
                            {/* View Button */}
                            <button
                              onClick={() => navigate(`${detailsRoute}${object?._id}`)}
                              className="group relative p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                              title="View Details"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              </svg>
                              <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                                View Details
                              </span>
                            </button>

                            {/* Verification Button */}
                            <button
                              onClick={() => {
                                setSelectedUser(object);
                                setShowVerificationModal(true);
                              }}
                              className="group relative p-2 text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50 rounded-lg transition-colors duration-200"
                              title="Manage Verification"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                              </svg>
                              <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                                Manage Verification
                              </span>
                            </button>

                            {object?.is_deleted ? (
                              /* Restore Button */
                              <button
                                onClick={() => {
                                  handleRestore(object);
                                }}
                                className="group relative p-2 text-green-600 hover:text-green-800 hover:bg-green-50 rounded-lg transition-colors duration-200"
                                title="Restore User"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                                  Restore User
                                </span>
                              </button>
                            ) : (
                              <>
                                {/* Delete Button */}
                                <button
                                  onClick={() => {
                                    setUserObject(object);
                                    setShow(true);
                                  }}
                                  className="group relative p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors duration-200"
                                  title="Delete User"
                                >
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                  </svg>
                                  <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                                    Delete User
                                  </span>
                                </button>

                                {/* Block/Unblock Button */}
                                <button
                                  onClick={() => {
                                    setUserObject(object);
                                    setShowblock(true);
                                    setBlockTitle(object.is_active === true ? "Block" : "Unblock");
                                  }}
                                  className={`group relative p-2 rounded-lg transition-colors duration-200 ${
                                    object.is_active
                                      ? "text-yellow-600 hover:text-yellow-800 hover:bg-yellow-50"
                                      : "text-green-600 hover:text-green-800 hover:bg-green-50"
                                  }`}
                                  title={object.is_active ? "Block User" : "Unblock User"}
                                >
                                  {object.is_active ? (
                                    <>
                                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728" />
                                      </svg>
                                      <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                                        Block User
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                      </svg>
                                      <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                                        Unblock User
                                      </span>
                                    </>
                                  )}
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Empty State */}
              {(!list?.data || list.data.length === 0) && (
                <div className="text-center py-12">
                  <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  <h3 className="mt-2 text-sm font-medium text-gray-900">No users found</h3>
                  <p className="mt-1 text-sm text-gray-500">
                    {search || filterUI.role || statusSelected.length > 0
                      ? "Try adjusting your search or filter criteria."
                      : "Get started by adding your first user."}
                  </p>
                </div>
              )}
            </div>
            <Pagination
              handlePageClick={handlePageClick}
              pageCount={Math.ceil((list?.totalItems || 0) / limit)}
            />
        </ContentWrapper>
      </LoadingOverlay>
      <DeleteModal
        show={show}
        handleClose={() => {
          setShow(false);
        }}
        handleDelete={handleDelete}
      />
      <BlockModal
        show={showblock}
        title={blockTitle}
        handleClose={() => {
          setShowblock(false);
        }}
        handleBlockActive={handleBlockActive}
      />
      <VerificationModal
        show={showVerificationModal}
        handleClose={() => {
          setShowVerificationModal(false);
          setSelectedUser(null);
        }}
        user={selectedUser}
      />
      <ReactTooltip id="verification-tip" />
    </Layout>
  );
}
